var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "row col-12 col-md-8 d-flex justify-content-center justify-content-md-start pl-md-0 mt-3 mt-md-0 styled-scrollbar-custom pr-under-md-0 pl-under-md-0",
      attrs: { id: "annonce-create-step-right-part" }
    },
    [
      _c(
        "div",
        {
          staticClass: "w-100",
          attrs: { id: "annonce-create-step-right-part-inside" }
        },
        [
          _c(
            "div",
            { staticClass: "col-12 pl-0 pr-0 mb-1" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "small-text",
                  attrs: {
                    label: _vm.$t("annonce.vehicle.need.image"),
                    "label-for": "vehicleFiles-input",
                    "invalid-feedback": _vm.imagesVehicleState.invalidFeedback,
                    state: _vm.imagesVehicleState.state
                  }
                },
                [
                  _c("b-form-file", {
                    ref: "vehicleFiles-input",
                    attrs: {
                      id: "vehicleFiles-input",
                      "browse-text": _vm.$t("Select"),
                      placeholder: "",
                      multiple: "",
                      "drop-placeholder": _vm.$t("drop-placeholder"),
                      required: "",
                      accept: ".png, .jpeg, .jpg"
                    },
                    on: {
                      input: function($event) {
                        return _vm.setAnnonce($event)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 pl-0 pr-0 mb-2" }, [
            _c("span", {
              staticClass: "custom-span-img",
              domProps: {
                innerHTML: _vm._s(_vm.$t("annonce.vehicle.one.image"))
              }
            })
          ]),
          _vm._v(" "),
          _c("PreviewSeveralImages", {
            attrs: { fileId: "recto", files: _vm.vehicleFiles },
            on: { deleteFileInPreview: _vm.deleteFile }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 pl-0 pr-0 mb-1 mt-4" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "small-text",
                  attrs: {
                    label: _vm.$t("annonce.vehicle.description"),
                    "label-for": "description-vehicle-input"
                  }
                },
                [
                  _c("b-form-textarea", {
                    attrs: {
                      state: _vm.vehicleDescription.state,
                      id: "description-vehicle-input"
                    },
                    on: { change: _vm.setAnnonce },
                    model: {
                      value: _vm.vehicleDescription.value,
                      callback: function($$v) {
                        _vm.$set(_vm.vehicleDescription, "value", $$v)
                      },
                      expression: "vehicleDescription.value"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-645bea24", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-645bea24","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/annonce/AnnonceCreate/AnnonceCreateStep6.vue
// module id = nc8y
// module chunks = 0